"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressSchema = void 0;
exports.addressSchema = {
    type: ['object', 'null'],
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [],
    properties: {
        municipalityName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 50,
            errorMessage: 'should be a string of length 50 or null',
        },
        postalCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should be a string of length 6 or null',
        },
        provinceCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should be a string of length 2 or null',
        },
        streetDirectionID: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should be a string of length 2 or null',
        },
        streetName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 50,
            errorMessage: 'should be a string of length 50 or null',
        },
        streetNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should be a string of length 10 or null',
        },
        streetTypeName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should be a string of length 7 or null',
        },
        unitNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should be a string of length 6 or null',
        },
    },
};
